module.exports = __webpack_public_path__ + "img/img49.3406a0ea.png";